<template>
  <div>
    <div class="start-session-container">
      <section style="margin: 0 0 2em 0">
        <h1>
          <span>Current Session</span>
          <span v-if="sessionActive" class="live indicator">Live</span>
          <!-- <span v-if="sessionEnded" class="ended indicator">Ended</span> -->
        </h1>
        <div class="session-details">
          <h3>
            Figure: {{ selectedFigure }}<br>
            Room: {{ selectedRoom }}
          </h3>
          <div v-if="sessionTimeLimitEnabled" class="flex-container-row stretch">
            <span>Time Limit: {{ sessionTimeLimit }} mins</span>
            <span>{{ sessionTimeRemainingTrim }}</span>
          </div>
        </div>
        <div
          v-if="sessionTimeLimitEnabled" style="margin: 1rem 0">
          <progress
            id="file"
            :value="sessionTimeRemaining"
            :max="sessionTimeLimit"
          ></progress>
          <span><em>Session started at {{getDate(liveSession.startDateTime)}} {{getTime(liveSession.startDateTime)}}</em></span>
        </div>
        <p v-if="!sessionTimeLimitEnabled">No Time Limit</p>
        <button v-if="sessionActive" @click="showModal">End Session</button>
        <button v-if="!sessionActive" @click="seeSessionAnalytics">
          See Session Analytics
        </button>
      </section>
      <hr />
      <section>
        <h1>Team Progress</h1>
        <ul class="group-list">
          <li v-for="(group, index) in allGroups" v-show="group.studentList.length > 0" :key="index">
            <div class="flex-container-row stretch">
              <h3>{{ group.groupName }} ({{ group.studentList.length }})</h3>
             <!--  <h4>
                <strong
                  ><span v-if="group.score > 0">+</span
                  >{{ group.score }}pts</strong
                >
              </h4> -->
            </div>
            <ul class="students-inline">
              <li
                v-for="student in group.studentList"
                class="student-name-item"
                style="white-space: pre-line"
                :key="student.studentId"
              >
                {{ student.studentName }}
              </li>
            </ul>
            <ul v-if="group.taskProgress" class="session-artifacts">
              <li :class="progressClass(0, group.taskProgress, group.stage) + ' flex-container-row stretch'">
                <h4>Fill-in-the-Blanks</h4>
                <h4>{{(group.taskProgress[1] === 4 || group.taskProgress[2] > 0) ? 8 : group.taskProgress[0]}} of 8</h4>
              </li>
              <li :class="progressClass(1, group.taskProgress, group.stage) + ' flex-container-row stretch'">
                <div style="width: 100%; display: flex; flex-direction: column;">
                  <div style="width: 100%; display:flex; justify-content:space-between;">
                    <h4>Artifacts</h4>
                    <h4>{{(group.taskProgress[2] > 0) ? 4 : group.taskProgress[1]}} of 4</h4>
                  </div>
                  <div v-if="group.stage == 0">
                    <div v-for="student in group.studentList"
                    :key="student.studentId"
                    style=" width:100%; display:flex; justify-content:space-between; margin-bottom: 0.5rem;"
                    >
                      <div style="padding-left: 1.5rem;">{{ student.studentName }}</div>
                      <div style="display: flex;">
                        <div style="padding-left: 0.25rem;" v-for="(star, idx) in groupArtifactStars(index, student)" :key="idx">
                          <img v-if="star.collected" src="@/assets/star_24px.svg"/>
                          <img v-else src="@/assets/star_border_24px.svg"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="progressClass(2, group.taskProgress, group.stage) + ' flex-container-row stretch'">
                <h4>Check for Understanding</h4>
                <h4>{{group.taskProgress[2]}} of 5</h4>
              </li>
            </ul>
            <ul class="group-options" v-if="!showOptions">
              <div style="display: flex; cursor: pointer;" @click="showOptions = !showOptions">
                <span class="material-icons-round">expand_more</span><u>Show Options</u>
              </div>
            </ul>
            <ul class="group-options" v-if="showOptions">
              <div style="display: flex; cursor: pointer;" @click="showOptions = !showOptions">
                <span class="material-icons-round">expand_less</span><u>Hide Options</u>
              </div>
            </ul>
            <ul class="group-options" v-if="showOptions">
              <button :class="isAdvanceToNextLevelButtonActive(group.stage)" style="font-weight: 700;" @click="advanceToNextLevel(group.groupName)">Move Team to Next Level</button>
            </ul>
          </li>
        </ul>
      </section>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal">
      <template v-slot:header>
        Are you sure you want to end the session?
      </template>

      <template v-slot:body>
        The session will terminate for all active students and session analytics will be available once session has ended successfully.
      </template>

      <template v-slot:footer>
        <div class="modal-button-group">
          <button @click="closeModal">Cancel</button>
          <button @click="endSession">End Session</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "../components/Modal.vue";

export default {
  name: "SessionData",
  components: {
    Modal,
  },
  props: ["name", "sessionActive"],
  data() {
    return {
      isModalVisible: false,
      showOptions: false
    };
  },
  computed: {
    currentClass() {
      const result = this.$store.state.allClasses.filter((response) => {
        return response.classInfo.nickname === this.$route.params.name
      });
      return result[0];
    },
    userType() {
      return this.$store.state.userType;
    },
    liveSession(){
      return this.$store.state.currentSession
    },
    sessionTimeLimitEnabled() {
      return this.liveSession.sessionSettings.isTimeLimitEnabled;
    },
    sessionTimeLimit() {
      return this.liveSession.sessionSettings.timeLimit;
    },
    sessionTimeRemaining() {
      return (
        this.sessionTimeLimit -
        (this.liveSession.updateSessionTimer / 60)
      );
    },
    sessionTimeRemainingTrim() {
      // const limit = this.sessionTimeLimit
      // const num = this.liveSession.updateSessionTimer / 60
      const mins = parseInt(
        this.liveSession.updateSessionTimer / 60,
        10
      );
      const secs = parseInt(
        this.liveSession.updateSessionTimer % 60,
        10
      );
      return mins + ":" + secs.toString().padStart(2, "0");
    },
    // sessionActive() {
    //   if (!this.sessionTimeLimitEnabled){
    //     return this.liveSession.sessionStarted;
    //   } else if (this.sessionTimeLimitEnabled && this.liveSession.updateSessionTimer >= 0){
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    groupCount() {
      return this.liveSession.groupList.length;
    },
    selectedFigure() {
      return this.liveSession.selectedStorybox.storyboxName;
    },
    selectedRoom() {
      return this.liveSession.selectedLevel.levelName;
    },
    allStudents() {
      return this.liveSession.studentList;
    },
    numStudentsJoined() {
      //console.log("STUDENTS", this.liveSession.studentList)
      return this.liveSession.studentList.filter(
        (student) => student.connectionState > 0
      ).length;
    },
    allGroups() {
      // const newList = this.liveSession.groupList.filter(
      //   (group) => group.studentList.length > 0
      // );
      return this.liveSession.groupList;
    },
    isDisabled() {
      return (
        this.liveSession.selectedStorybox == "" ||
        this.liveSession.selectedLevel == ""
      );
    },
  },
  methods: {
    isAdvanceToNextLevelButtonActive(stage) {
      return stage <= 2 && this.sessionActive ? '' : 'disabled';
    },
    advanceToNextLevel(groupName) {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          sessionId: this.liveSession.sessionId,
          groupName: groupName,
        },
        opCode: this.$store.state.opCodes.AdvanceGroupStage,
      });
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    groupArtifactStars: function(groupIdx, student){
      var artifacts = this.liveSession.groupList[groupIdx].artifactsList.filter(artifact => artifact.assigned == student.studentId);
      artifacts.sort(function(x, y) {
        return (x.collected === y.collected) ? 0 : x.collected ? 1 : -1;
      });
      return artifacts;
    },
    getDate: function(timestamp){
      return this.$filters.getDate(timestamp);
    },
    getTime: function(timestamp){
      return this.$filters.getTime(timestamp);
    },
    progressClass: function (taskIdx, taskProgress, stage) {
      if ((stage >= 1 && taskIdx <= 1) || (stage == 2 && taskIdx == 2))
      {
        return 'status_completed';
      }
      switch (taskIdx) {
        case 0: {
          if (taskProgress[1] === 4 || taskProgress[2] > 0) {
            return 'status_completed';
          }
          if (taskProgress[0] === 0) {
            return 'status_unstarted';
          }
          else if (taskProgress[0] > 0 && taskProgress[0] < 8) {
            return 'status_inprogress';
          }
          else {
            return 'status_completed';
          }
        }
        case 1: {
          if (taskProgress[2] > 0) {
            return 'status_completed';
          }
          if (taskProgress[1] === 0) {
            return 'status_unstarted';
          }
          else if (taskProgress[1] > 0 && taskProgress[1] < 4) {
            return 'status_inprogress';
          }
          else {
            return 'status_completed';
          }
        }
        case 2: {
          if (stage == 2) {
            return 'status_completed';
          }
          if (taskProgress[2] === 0) {
            return 'status_unstarted';
          }
          else if (taskProgress[2] > 0 && taskProgress[2] < 5) {
            return 'status_inprogress';
          }
          else {
            return 'status_completed';
          }
        }
      }
    },
    endSession: function () {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          sessionId: this.liveSession.sessionId,
          teacherId: this.$store.state.teacherId,
        },
        opCode: this.$store.state.opCodes.EndSession,
      });
      this.isModalVisible = false;
    },
    seeSessionAnalytics: function () {
      this.$store.commit ("SET_SESSION_ID", this.liveSession.sessionId);
      this.$store.commit("SEND_MESSAGE", {
        data: this.liveSession.sessionId,
        opCode: this.$store.state.opCodes.PastSessionData,
      });
      this.$router.push({
        name: "session-analytics",
        params: { 
          name: this.currentClass.classInfo.nickname, 
          session: this.liveSession.sessionId
        },
      });
    },
  },
};
</script>

<style lang="scss">
h1 span {
  vertical-align: middle;
  font-size: 36px;
  &.indicator {
    background: $green;
    padding: 5px 10px;
    font-size: 0.5em;
    color: white;
    border-radius: 10px;
    margin-left: 0.5em;
  }
  &.live {
    background: $green;
  }
  &.ended {
    background: $bluegrey;
  }
}
button {
  width: 100%;
}
.session-details {
  h3 {
    margin-bottom: 0;
  }
  span {
    font-size: 1.17em;
    &:last-of-type {
      font-size: 1.7em;
      font-weight: bold;
    }
  }
}
</style>